import { MyCurrentStatusPage } from "./myCurrentStatus";

export const MyCurrentStatus = MyCurrentStatusPage;
